module.exports = {
    ddsSpace: "dds",
    ddsToken: "__",
    fontVersion: "2.137.1",
    iconVersion: "2.6.0",
    prefix: "dds__",
    iconPrefix: "dds__icon--",
};
